// extracted by mini-css-extract-plugin
export var box = "_7r-1";
export var checkboxRow = "_7r-8";
export var checked = "_7r-2";
export var descriptionSpacer = "_7r-a";
export var disabled = "_7r-3";
export var icon = "_7r-6";
export var input = "_7r-0";
export var labelSpacer = "_7r-9";
export var medium = "_7r-5";
export var small = "_7r-4";
export var text = "_7r-7";